<template lang="pug">
  tr
    td
      action-type(:data="action" data-key="type")
    td {{ templateName }}
    td {{ templateContent }}
    td {{ action.notes }}
    td {{ action.schedule }}
    td
      span(v-if="action.is_stopped_on_text_reply") Yes
</template>

<script>
import ActionType from './CampaignActionType';

export default {
  components: { ActionType },
  props: {
    action: {
      type: Object,
      required: true,
    },
  },
  computed: {
    templateName() {
      const { template } = this.action;
      if (template) return template.description;
    },
    templateContent() {
      const { template } = this.action;
      if (template) return template.subject;
    },
  },
};
</script>
